export default "__VITE_ASSET__BhKJrxPs__"